import { render, staticRenderFns } from "./quienes-somos.vue?vue&type=template&id=c7bb34e2&scoped=true&"
import script from "./quienes-somos.vue?vue&type=script&lang=js&"
export * from "./quienes-somos.vue?vue&type=script&lang=js&"
import style0 from "./quienes-somos.vue?vue&type=style&index=0&id=c7bb34e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bb34e2",
  null
  
)

export default component.exports